import React, { useState, useEffect } from 'react';
import { Routes, Route, Link, useLocation, useNavigate } from 'react-router-dom';

import { showModal, Modal } from '../components/Modal.js';

import Logo from '../Logo.js';
import UserPicture from '../components/UserPicture';
import TransactionNew from '../modals/TransactionNew.js';

function TopBar({scrollAtTop, heading = null, showLogo = false, showActions = true}) {
    const userPictureUrl = 'https://r2.serverbook.app/user-image/9e1a4260ea970fb37721bd9c968e2db8-medium.jpg';

    const handleShowModal = () => {
        showModal(
            <Modal heading='New Transaction'>
                <TransactionNew />
            </Modal>
        );
    };



    return (
        <div className={`fixed w-full z-50 top-0 left-0 px-6 top-bar-spacing flex items-center justify-between transition-colors duration-100 before:block before:absolute before:left-0 before:top-0 before:w-full before:h-full before:bg-white/30 before:backdrop-blur-xl before:border-b-[1px] before:border-black/10 dark:before:bg-slate-950/30 dark:before:border-white/10 before:z-[-1] before:transition-opacity before:duration-100 ${scrollAtTop ? 'before:opacity-0' : ''}`}>
        
            {showLogo && <Logo className='block h-8' />}
            {heading && <h1 className='text-xl font-bold dark:text-white'>{heading}</h1>}
            {showActions && 
                <div className='flex relative gap-2'>
                    <button className='block relative h-9 w-9'>
                        <UserPicture pictureSrc={userPictureUrl} />
                    </button>
                    <button className='block relative h-9 w-9 bg-slate-950 dark:bg-white rounded-full ring-1 ring-black ring-opacity-10 ring-inset' onClick={handleShowModal}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" className='h-5 absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] fill-white dark:fill-slate-950'>
                            <path d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 144L48 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0 0 144c0 17.7 14.3 32 32 32s32-14.3 32-32l0-144 144 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-144 0 0-144z"/>
                        </svg>
                    </button>
                </div>
            }
        </div>
    );
}

export default TopBar;